import { setImages } from '../redux/slice/sketchSlice';
import {
  setImageBatchUploadStatus,
  clearUploadingImages,
  setImageUploadStatus,
  setLineartProgressByBook,
} from '../redux/slice/stepSlice';
import { updateBook } from '../redux/slice/profileSlice';
import { clearPendingImages, clearExpectedInteriorPageCount } from './pendingImageStorage';

/**
 * Every interior page of this book has its drawing: clear the run's local
 * state so Choose Photos unlocks and the progress cards close. Called by the
 * socket's completed handlers and by the server check (useBookPagesFromServer)
 * when the phone missed that event. `merged` is the fresh grid for Choose
 * Photos (fetchOrderedInteriorImages), or omit it to leave the grid alone.
 */
export const markLineartRunFinished = (dispatch, bookId, merged) => {
  if (!bookId) return;
  if (merged) dispatch(setImages(merged));
  clearPendingImages(bookId);
  clearExpectedInteriorPageCount(bookId);

  dispatch(setImageBatchUploadStatus(false));
  dispatch(clearUploadingImages());
  dispatch(setImageUploadStatus(false));
  // The progress flag and the book's own isProcessing copy (loaded mid-run
  // after a reload) both lock Choose Photos, so both are cleared.
  dispatch(setLineartProgressByBook({ bookId, isProcessing: false, overallPercentage: 100 }));
  dispatch(updateBook({ _id: bookId, isProcessing: false, processingPercentage: 100 }));
};
